/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetAuthMeParams,
  PutAuthMeAvatarBody,
  TrainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest,
  TrainWithMeModulesAccountsDtosResponsesAvatarResponse,
  TrainWithMeModulesAccountsDtosResponsesGetMeResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postAuthCompleteProfile = (
    trainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest?: BodyType<TrainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAccountsDtosResponsesGetMeResponse>(
      {url: `/auth/complete-profile`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest, signal
    },
      options);
    }




export const getPostAuthCompleteProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthCompleteProfile>>, TError,{data?: BodyType<TrainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthCompleteProfile>>, TError,{data?: BodyType<TrainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest>}, TContext> => {

const mutationKey = ['postAuthCompleteProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthCompleteProfile>>, {data?: BodyType<TrainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postAuthCompleteProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAuthCompleteProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthCompleteProfile>>>
    export type PostAuthCompleteProfileMutationBody = BodyType<TrainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest> | undefined
    export type PostAuthCompleteProfileMutationError = ErrorType<unknown>

    export const usePostAuthCompleteProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthCompleteProfile>>, TError,{data?: BodyType<TrainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthCompleteProfile>>,
        TError,
        {data?: BodyType<TrainWithMeModulesAccountsDtosRequestsPostCompleteProfileRequest>},
        TContext
      > => {
      return useMutation(getPostAuthCompleteProfileMutationOptions(options), queryClient);
    }
    export const getAuthMe = (
    params?: GetAuthMeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAccountsDtosResponsesGetMeResponse>(
      {url: `/auth/me`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAuthMeQueryKey = (params?: GetAuthMeParams,) => {
    return [
    `/auth/me`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorType<unknown>>(params?: GetAuthMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthMeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMe>>> = ({ signal }) => getAuthMe(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMe>>>
export type GetAuthMeQueryError = ErrorType<unknown>


export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorType<unknown>>(
 params: undefined |  GetAuthMeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getAuthMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorType<unknown>>(
 params?: GetAuthMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getAuthMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorType<unknown>>(
 params?: GetAuthMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorType<unknown>>(
 params?: GetAuthMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthMeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteAuthMeAvatar = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/auth/me/avatar`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAuthMeAvatarMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAuthMeAvatar>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAuthMeAvatar>>, TError,void, TContext> => {

const mutationKey = ['deleteAuthMeAvatar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAuthMeAvatar>>, void> = () => {


          return  deleteAuthMeAvatar(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAuthMeAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAuthMeAvatar>>>

    export type DeleteAuthMeAvatarMutationError = ErrorType<unknown>

    export const useDeleteAuthMeAvatar = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAuthMeAvatar>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAuthMeAvatar>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteAuthMeAvatarMutationOptions(options), queryClient);
    }
    export const putAuthMeAvatar = (
    putAuthMeAvatarBody?: BodyType<PutAuthMeAvatarBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(putAuthMeAvatarBody?.file !== undefined) {
 formData.append(`file`, putAuthMeAvatarBody.file);
 }

      return customInstance<TrainWithMeModulesAccountsDtosResponsesAvatarResponse>(
      {url: `/auth/me/avatar`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPutAuthMeAvatarMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthMeAvatar>>, TError,{data?: BodyType<PutAuthMeAvatarBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putAuthMeAvatar>>, TError,{data?: BodyType<PutAuthMeAvatarBody>}, TContext> => {

const mutationKey = ['putAuthMeAvatar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuthMeAvatar>>, {data?: BodyType<PutAuthMeAvatarBody>}> = (props) => {
          const {data} = props ?? {};

          return  putAuthMeAvatar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAuthMeAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof putAuthMeAvatar>>>
    export type PutAuthMeAvatarMutationBody = BodyType<PutAuthMeAvatarBody> | undefined
    export type PutAuthMeAvatarMutationError = ErrorType<unknown>

    export const usePutAuthMeAvatar = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthMeAvatar>>, TError,{data?: BodyType<PutAuthMeAvatarBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAuthMeAvatar>>,
        TError,
        {data?: BodyType<PutAuthMeAvatarBody>},
        TContext
      > => {
      return useMutation(getPutAuthMeAvatarMutationOptions(options), queryClient);
    }
